import { useEffect, useRef, useState } from "react";
import { Users, CheckCircle } from "lucide-react";
import Card from "../components/ui/Card";
import LiveCommunityRecitation from "../components/ui/LiveCommunityRecitation";

const victoryNotes = [
	{
		id: 1,
		user: "Striver92",
		message:
			"Replaced my 11 PM routine with 2 rakats. Feeling peaceful.",
	},
	{
		id: 2,
		user: "Seeker10",
		message:
			"Fought the 'numbness' today by calling my mother. Connection wins.",
	},
	{
		id: 3,
		user: "User404",
		message:
			"5-4-3-2-1 rule worked! I got out of the room before the urge took over.",
	},
	{
		id: 4,
		user: "PathFinder",
		message:
			"Day 15. The 'auto-pilot' is getting quieter. Alhamdullilah.",
	},
];

export default function PulsePage() {
	const [liveCount, setLiveCount] = useState(1284);
	const intervalRef = useRef();

	useEffect(() => {
		intervalRef.current = setInterval(() => {
			setLiveCount((c) => c + Math.floor(Math.random() * 2) + 1);
		}, Math.floor(Math.random() * 3000) + 2500);
		return () => clearInterval(intervalRef.current);
	}, []);

	return (
		<div className="space-y-2 flex flex-col" style={{ paddingBottom: "calc(80px + env(safe-area-inset-bottom, 20px))" }}>
			{/* Community Pulse Header */}
			<Card className="bg-gradient-to-r from-emerald-950/20 to-transparent border border-[#10B981]/30 relative overflow-hidden">
				<div className="relative z-10 flex flex-col items-center py-5">
					<div className="flex items-center gap-2 mb-1">
						<span className="text-2xl font-bold text-[#10B981] glow-mint">
							{liveCount.toLocaleString()}
						</span>
						<span className="relative flex h-3 w-3">
							<span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#10B981] opacity-75"></span>
							<span className="relative inline-flex rounded-full h-3 w-3 bg-[#10B981]"></span>
						</span>
						<span className="text-sm font-medium text-zinc-300">
							Hearts Striving Together
						</span>
					</div>
					<div className="text-xs text-zinc-600">
						You are not fighting this alone.
					</div>
				</div>
			</Card>

			{/* Daily Halaqa - Now Live Community Recitation */}
			<LiveCommunityRecitation />

			{/* Wall of Sabr */}
			<div>
				<div className="flex items-center gap-2 mb-2">
					<Users size={20} className="text-mint-accent" />
					<span className="text-xs uppercase tracking-widest text-white font-semibold">
						Wall of Sabr
					</span>
				</div>
				<div className="space-y-2">
					{victoryNotes.map((note) => (
						<Card key={note.id} className="flex items-center gap-3">
							<CheckCircle
								size={18}
								className="text-[#10B981] glow-mint flex-shrink-0"
							/>
							<div>
								<div className="text-xs text-zinc-600 uppercase tracking-widest font-semibold">
									{note.user}
								</div>
								<div className="text-sm text-zinc-400">
									{note.message}
								</div>
							</div>
						</Card>
					))}
				</div>
			</div>
		</div>
	);
}